<!-- <div class="card">
  <div class="card-header">
    <i class="fa fa-street-view"></i> Notas de crédito
  </div>
  <div class="card-body card-body-z-index">
    
  </div>
</div> -->

<pos-table tableFormId="creditNotesTable" [data]="creditNotes" [headers]="getCreditNotesHeaders()"
      [filters]="getCreditNotesFilters()" (dataChange)="getCreditNotesData($event)" [itemsPerPage]="10" [disableHighlight]="true">
    </pos-table>